import React from 'react'
import { Modal, ModalHeader, Media, ModalBody, ModalFooter, Col, Button, Row } from 'reactstrap';

export const ModalConfirmReleaseAll = (props) => {

    const {
        modalRelease, toggleRelease, loadingRelease, releaseAll
    } = props;

    return (
        <Modal isOpen={modalRelease} toggle={toggleRelease} backdrop='static' keyboard={false} centered={true} className="modal-lg" >
            <ModalHeader toggle={toggleRelease} className="bg-primary">
                ADVERTENCIA
            </ModalHeader>
            <ModalBody>
                <h5>
                    Al aceptar, esta acción va a <b>LIBERAR</b> todos los estudios que ya se encuentren validados.
                </h5>
            </ModalBody>
            <ModalFooter>
                <Button outline color="primary" type="button" onClick={() => releaseAll()} size="sm" disabled={loadingRelease} className={loadingRelease ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    Aceptar, liberar todo
                </Button>
                <Button size="sm" outline color='danger' type="button" onClick={toggleRelease}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Modal>
    )
}
